/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuppliersSectionParameters
 */
export interface SuppliersSectionParameters {
    /**
     * 
     * @type {Array<number>}
     * @memberof SuppliersSectionParameters
     */
    buyerIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SuppliersSectionParameters
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SuppliersSectionParameters
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SuppliersSectionParameters
     */
    excludeSignalCategories?: Array<string>;
}

/**
 * Check if a given object implements the SuppliersSectionParameters interface.
 */
export function instanceOfSuppliersSectionParameters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "buyerIds" in value;

    return isInstance;
}

export function SuppliersSectionParametersFromJSON(json: any): SuppliersSectionParameters {
    return SuppliersSectionParametersFromJSONTyped(json, false);
}

export function SuppliersSectionParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuppliersSectionParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'buyerIds': json['buyer_ids'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'excludeSignalCategories': !exists(json, 'exclude_signal_categories') ? undefined : json['exclude_signal_categories'],
    };
}

export function SuppliersSectionParametersToJSON(value?: SuppliersSectionParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'buyer_ids': value.buyerIds,
        'title': value.title,
        'description': value.description,
        'exclude_signal_categories': value.excludeSignalCategories,
    };
}

